import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import compare from './compare/reducer';
import endpoints from './endpoints/reducer';
import metrics from './metrics/reducer';
import ui from './ui/reducer';
import auth from './auth/reducer';
import favorites from './favorites/reducer';

export default (history) =>
  combineReducers({
    router: connectRouter(history),
    compare,
    endpoints,
    metrics,
    ui,
    auth,
    favorites,
  });
